import React, {useEffect, useState} from 'react';
import './Admin.css';
import axios from "axios";
import {useNavigate} from "react-router-dom";
import AdminHeader from "./AdminHeader/AdminHeader";

const Admin = () => {

    const navigate = useNavigate();

    const [light, setLight] = useState(false);
    const [door, setDoor] = useState(false);

    useEffect(() => {
        axios.get(`/api/get_device_status/`, {headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers': 'X-CSRFToken'
            }, withCredentials: true})
            .then(res => {
                setLight(res.data.light_on);
                setDoor(res.data.door_open);
            })
            .catch(e => {
                console.log(e);
            })
    }, [setLight, setDoor])

    const goToUserSearch = () => {
        navigate('/admin_user_search');
    }

    const goToAdminBoxes = () => {
        navigate('/admin_boxes');
    }

    const goToAdminEquipment = () => {
        navigate('/admin_equipment');
    }

    const turnLightOn = () => {
        axios.get(`/api/turn_on_light/`, {headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers': 'X-CSRFToken'
            }, withCredentials: true})
            .then(res => {
                console.log('Light on');
            })
            .catch(e => {
                console.log(e);
            })

        setLight(true);
    }

    const turnLightOff = () => {
        axios.get(`/api/turn_off_light/`, {headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers': 'X-CSRFToken'
            }, withCredentials: true})
            .then(res => {
                console.log('Light off');
            })
            .catch(e => {
                console.log(e);
            })

        setLight(false);
    }

    const turnDoorOn = () => {
        axios.get(`/api/open_door/`, {headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers': 'X-CSRFToken'
            }, withCredentials: true})
            .then(res => {
                console.log('Door open');
            })
            .catch(e => {
                console.log(e);
            })

        setDoor(true);
    }

    const turnDoorOff = () => {
        axios.get(`/api/close_door/`, {headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers': 'X-CSRFToken'
            }, withCredentials: true})
            .then(res => {
                console.log('Door close');
            })
            .catch(e => {
                console.log(e);
            })

        setDoor(false);
    }

    return (
        <div className={'admin-page-container'}>
            <AdminHeader/>
            <div className={'admin-players-block'}>
                <p className={'admin-players-title'}>Игроки</p>
                <div className={'admin-players-button'} onClick={() => goToUserSearch()}>Список</div>
            </div>
            <div className={'admin-light-block'}>
                <p className={'admin-light-title'}>Свет на корте</p>
                <div className={'admin-light-buttons'}>
                    <div className={`admin-light-on ${light ? 'device-off' : ''}`}
                         onClick={() => turnLightOn()}>Включить
                    </div>
                    <div className={`admin-light-off ${light ? '' : 'device-off'}`}
                         onClick={() => turnLightOff()}>Выключить
                    </div>
                </div>
            </div>
            <div className={'admin-lock-block'}>
                <p className={'admin-lock-title'}>Замок двери</p>
                <div className={'admin-lock-buttons'}>
                    <div className={`admin-lock-on ${door ? 'device-off' : ''}`} onClick={() => turnDoorOn()}>Открыть
                    </div>
                    <div className={`admin-lock-off ${door ? '' : 'device-off'}`}
                         onClick={() => turnDoorOff()}>Закрыть
                    </div>
                </div>
            </div>
            <div className={'admin-boxes-block'}>
                <p className={'admin-boxes-title'}>Шкафы</p>
                <div className={'admin-boxes-button'} onClick={() => goToAdminBoxes()}>Список</div>
            </div>
            <div className={'admin-equipment-block'}>
                <p className={'admin-equipment-title'}>Инвентарь</p>
                <div className={'admin-equipment-button'} onClick={() => goToAdminEquipment()}>Список</div>
            </div>
        </div>
    );
};

export default Admin;